import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'
import { Address, RelativeData } from 'models/Auth'

interface ME {
  id: number,
  username: string,
  person_general: {
    first_name: string,
    last_name: string,
    full_name: string,
    email: string,
    cpf: string,
    date_birth: string,
    date_created: string,
    date_published: string,
    cellphone_number: string,    
    phone_number: string,
    picture_url: string,
    gender: string,
    address_data: Address,
    relative_data: RelativeData    
  }
}

export async function getUserData(): Promise<ME> {
  const { data } = await axios.get<ME>(apiEndpoints.ME)

  return data
}